import moment from "moment";
import coresPadrao from '@/common/situacoes.cores'

export default {
    filtroClientes: null,
    dataAtual: moment().format("YYYY-MM-DD"),
    filtroServicos: [],
    filtroProfissionais: [],
    filtroFuncoes: [],
    listaProfissionais: [],
    listaServicos: [],
    listaFuncoes: [],
    parametros: null,
    sessaoAgendamento: {autenticado: false, parametros: null, sessao: null},
    requisicoes: false,
    tipoAgenda: "profissionais",
    erro: null,
    coresAgenda: Object.assign({}, coresPadrao),
    funcaoCoresItems: null,
    autenticacaoMicrovixAgendamentoOnline: { autenticado: false, alias: null },
    autenticacaoMicrovixAgenda: { autenticado: false },
    sessaoAgendamentoOnline: {autenticado: false, sessao: null},
    paramsComanda: {idComanda: null, dataAgendamento: null, idProfissional: null},
    configVisualAgendamentoOnline: {corPrimaria: "#2c004b", corSecundaria: "#5b2e90", imagem: 'https://stgmvxdevimagens.blob.core.windows.net/9056-1/44ff5cf4-fee9-41b8-b78e-932593737412.jpg', mensagemCustomizada: 'BEM VINDO!'},
};
